export const GET_DIVISIONS_WATCHER =
  "app/WidgetResultByDivision/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/WidgetResultByDivision/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/WidgetResultByDivision/GET_DIVISIONS_FAILED"
export const GET_DIVISIONS_BY_DIMENSION_WATCHER = "app/WidgetResultByDivision/GET_DIVISIONS_BY_DIMENSION_WATCHER"
export const GET_DIVISIONS_BY_DIMENSION_SUCCESS = "app/WidgetResultByDivision/GET_DIVISIONS_BY_DIMENSION_SUCCESS"
export const GET_DIVISIONS_BY_DIMENSION_FAILED = "app/WidgetResultByDivision/GET_DIVISIONS_BY_DIMENSION_FAILED"
